import styled from 'styled-components';

export const AppointmentContainer = styled.div`
  display: grid;
  grid-template-columns: min-content auto min-content;
  gap: ${({ theme }) => theme.core.sizing[1]}px;

  /* padding: ${({ theme }) => theme.core.sizing[2]}px; */

  /* border-radius: ${({ theme }) => theme.core.border.element.radius}px; */

  /* border: 0.5px solid ${({ theme }) => theme.core.colors.greyscale.dark}; */
`;

export const CalendarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  align-self: flex-start;

  grid-row: 1 / span 1;
  grid-column: 1 / span 1;

  width: 50px;

  padding: ${({ theme }) => theme.core.sizing[1]}px;

  border: 0.5px solid ${({ theme }) => theme.core.colors.greyscale.dark};
  border-radius: ${({ theme }) => theme.core.border.element.radius}px;

  background: ${({ theme }) => theme.core.colors.greyscale.white};

  > span {
    &:first-of-type {
      color: ${({ theme }) => theme.core.colors.primary.green.medium};
      font-size: ${({ theme }) => theme.core.fontSizes.l}px;
      font-weight: ${({ theme }) => theme.core.fontWeight.medium};
    }

    &:last-of-type {
      color: ${({ theme }) => theme.core.colors.greyscale.dark};
      font-size: ${({ theme }) => theme.core.fontSizes.sm}px;
    }
  }

  /* ${({ theme }) => theme.breakpoints.up('lg')} { */
  grid-row: 1 / span 2;
  grid-column: 1 / span 1;
  /* } */
`;

export const AppointmentTitle = styled.div`
  grid-column: 1 / span 3;
  grid-row: 2 / span 1;

  font-size: ${({ theme }) => theme.core.fontSizes.xl}px;
  font-weight: ${({ theme }) => theme.core.fontWeight.medium};

  /* ${({ theme }) => theme.breakpoints.up('lg')} { */
  grid-row: 1 / span 1;
  grid-column: 2 / span 1;
  /* } */
`;

export const AppointmentDateAndTime = styled.div`
  grid-column: 1 / span 3;

  /* ${({ theme }) => theme.breakpoints.up('lg')} { */
  grid-row: 2 / span 1;
  grid-column: 2 / span 2;
  /* } */
`;

export const AppointmentStatus = styled.div`
  grid-column: 3 / span 1;
  grid-row: 1 / span 1;
`;

export const AppointmentWorkplace = styled.div`
  grid-column: 2 / span 1;
`;

export const AppointmentItemsContainer = styled.div`
  grid-column: 1 / span 3;
`;

export const AppointmentItemContainer = styled.div``;

export const AppointmentTotalsContainer = styled.div`
  grid-column: 2 / span 2;
`;

export const ActionsContainer = styled.div`
  grid-column: 1 / span 3;

  align-self: flex-end;
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.core.sizing[2]}px;

  button {
    height: 32px;

    padding: 0 20px;
  }
`;
